// extracted by mini-css-extract-plugin
export var card = "_46-0";
export var content = "_46-1";
export var contentLoading = "_46-2";